export const DETAILS = "Details";
export const DURATION = "Duration";
export const RUNTIME = "Runtime";
export const TYPE = "Type";
export const PROFILE = "Profile";
export const PROTOCOL = "Protocol";
export const CHOOSE_ONE = "Choose one";
export const ENCRYPTION_TYPE = "Encryption Type";
export const QUALITY_GROUP = "Quality Group";
export const AD = "Ad";
export const LICENSE_URL = "License URL";
export const CONTENT_URL = "Content URL";
export const MEDIA_UPLOAD = "Media Upload";
export const BROWSE_VIDEO = "Browse Video";
export const TRANSCODE_VIDEO = "Transcode Video";
export const DRM_ENABLE = "Do you want to enable the DRM ?";
export const UPLOADING_VIDEO = "Uploading video";
export const TRANSCODING_VIDEO = "Transcoding video";
export const CHOOSE_BITRATES = "Choose Bitrates";
export const UPLOADING = "Uploading";
export const TRANSCODE = "Transcode";
export const TRANSCODING = "Transcoding";
export const COMPLETED = "Completed";
export const UPLOAD = "Upload";
export const REMOVE = "Remove";
export const META_DATA_DESCRIPTION =
  "Complete your video workflow: Add detailed metadata, upload the video, and transcode for playback.";

export const AVAILABLE_BITRATES = {
  pixel_1080: "1080p",
  pixel_720: "720p",
  pixel_540: "540p",
  pixel_360: "360p",
  pixel_270: "270p",
  pixel_180: "180p",
};

export const BITRATE_VALUES = {
  pixel_1080: {
    video_bitrate: {
      resolution: "1920x1080",
      bitrate: "5000k",
      codec: "libx264",
      framerate: "30",
    },
    audio_bitrate: {
      bitrate: "192k",
      codec: "aac",
    },
  },
  pixel_720: {
    video_bitrate: {
      resolution: "1280x720",
      bitrate: "2500k",
      codec: "libx264",
      framerate: "30",
    },
    audio_bitrate: {
      bitrate: "128k",
      codec: "aac",
    },
  },
  pixel_540: {
    video_bitrate: {
      resolution: "960x540",
      bitrate: "1500k",
      codec: "libx264",
      framerate: "30",
    },
    audio_bitrate: {
      bitrate: "128k",
      codec: "aac",
    },
  },
  pixel_360: {
    video_bitrate: {
      resolution: "640x360",
      bitrate: "800k",
      codec: "libx264",
      framerate: "30",
    },
    audio_bitrate: {
      bitrate: "96k",
      codec: "aac",
    },
  },
  pixel_270: {
    video_bitrate: {
      resolution: "480x270",
      bitrate: "500k",
      codec: "libx264",
      framerate: "30",
    },
    audio_bitrate: {
      bitrate: "96k",
      codec: "aac",
    },
  },
  pixel_180: {
    video_bitrate: {
      resolution: "320x180",
      bitrate: "300k",
      codec: "libx264",
      framerate: "30",
    },
    audio_bitrate: {
      bitrate: "64k",
      codec: "aac",
    },
  },
};
